'use client';
import { useRef, useEffect, FC, PropsWithChildren } from 'react';
import { CatPopover } from '@blocks-react/components/Popover';
import { CatButton } from '@blocks-react/components/Button';
import styles from './restrictions.module.scss';
import { bannerTexts } from '../../../constants';

export type Restriction = [string, string, string[]];

interface RestrictionPopoverInterface {
  content: Restriction[];
}

export const RestrictionPopover: FC<
  PropsWithChildren<RestrictionPopoverInterface>
> = ({ children, content = [] }) => {
  const popoverRef = useRef(null);

  useEffect(() => {
    const popoverShown = sessionStorage.getItem('popoverShown');
    // Open the popover only if it hasn't been shown before
    const restrictionsPopoverShown = sessionStorage.getItem(
      'restrictionsPopoverShown'
    );
    // Open the popover only if it hasn't been shown before
    if (
      Boolean(content[0]?.length) &&
      !popoverShown &&
      !restrictionsPopoverShown
    ) {
      popoverRef.current.open();
      sessionStorage.setItem('popoverShown', 'true');
      sessionStorage.setItem('restrictionsPopoverShown', 'true');
    }
  }, [content]);

  if (!content[0]?.length) {
    return children;
  }

  return (
    <CatPopover
      ref={popoverRef}
      headingVariant="title-sm"
      heading={bannerTexts.RESTRICTIONS_APPLIED}
      className={styles.popoverContainer}
      behavior="responsive"
    >
      <div className={styles.popoverContainer__trigger} slot="trigger">
        {children}
      </div>
      <div className={styles.popoverContainer__wrapper}>
        {content.map(([title, subtitle, limitations]) => (
          <div
            className={styles.popoverContainer__wrapper__body}
            key={`${title}-${subtitle}`}
          >
            <p className={styles.popoverContainer__wrapper__body__title}>
              {title}
            </p>
            <p className={styles.popoverContainer__wrapper__body__subtitle}>
              {subtitle}
            </p>
            <ul className={styles.popoverContainer__wrapper__body__list}>
              {limitations.map((restriction) => (
                <li key={`${restriction}`}>{restriction}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <CatButton onClick={() => popoverRef.current.close()}>
        {bannerTexts.CSR_CLOSE}
      </CatButton>
    </CatPopover>
  );
};

export default RestrictionPopover;
